import React, { useEffect, useState } from "react";
import Section_title from "../../../common-components/section-title/Section_title";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/master/country/Slice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import Add from "./Add";
import Pagination_Holder from "../../../common-components/Pagination_Holder/Pagination_Holder";
import Table_search from "../../../common-components/table-search/Table_search";
import { useSelector } from "react-redux";
import Delete_Modal from "../../../common-components/common_Modal/Delete_Modal/Delete_Modal";
import Delete_Confirm_Modal from "../../../common-components/common_Modal/Delete_Confirm_Modal/Delete_Confirm_Modal";
import Confirm_Status_Change from "../../../common-components/common_Modal/Confirm_Status_Change/Confirm_Status_Change";
const Table = () => {
  const dispatch = useDispatch();

  const {
    coupon,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  } = IndexUse();

  const couponCategory = useSelector(
    (state) => state.common.all_coupon_category,
  );

  const [add, setAdd] = useState(false);
  const [edit, setEdit] = useState(false);
  const [rdelete, setRDelete] = useState(false);
  const [showError, setShowError] = useState("");
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);

  const [id, setId] = useState("");

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const handleDeleteModal = async (id) => {
    await setDeleteConfirmModal(id);
  };

  const handleDelete = async (id) => {
    await setDeleteConfirmModal(false);
    const success = await deleteData(id);
    setRDelete(false);
    if (success) setSuccess(true);
    else setErr(true);
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);

    if (success) {
      await fetch();
      setRDelete(false);
      setStatusConfirmModal(false);
    } else {
      setErr(true);
    }
  };

  const [statusConfirmModal, setStatusConfirmModal] = useState(false);
  const handleStatusModal = async (id) => {
    await setStatusConfirmModal(id);
  };
  return (
    <section className="content_body section_box">
      <div className="top_title_sec">
        <div className="forms_section">
          <div className="row align-items-end">
            <div className="col-md-12">
              <Section_title title="Coupon" alltotal="" />
            </div>
            {/* <div className="col-md-5 mb-3 ps-0">
            <Table_search name={name} setName={setName} fetch={fetch} />
          </div> */}
            <div className="col-md-4 mb-3 form-group">
              <label className="form-label">Filter by Title</label>
              <Form.Control
                type="text"
                placeholder="Enter Title"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-md-4 mb-3" style={{ width: "fit-content" }}>
              <button
                className="btn btn-danger "
                onClick={() => {
                  setName("");
                }}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <Add
        id={id}
        setId={setId}
        setSuccess={setSuccess}
        setErr={setErr}
        showError={showError}
        setShowError={setShowError}
      />

      <div className="table_section theme_bg">
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S. no.</th>
                <th>Title</th>
                <th>Description</th>
                <th>Discount</th>
                <th>Minimum Fare</th>
                <th>Use Per Coupon</th>
                <th>Use Per Customer</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Image</th>
                <th>Vehicle Categories</th>
                <th>status </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {coupon?.data?.data?.length > 0 ? (
                coupon?.data.data?.map((val, index) => (
                  <tr key={index}>
                    <td>
                      {(coupon?.data?.current_page - 1) *
                        coupon?.data?.per_page +
                        index +
                        1}
                    </td>
                    <td>{val?.title}</td>
                    <td>{val?.description}</td>
                    <td>
                      {val?.discount}
                      {val?.type === "Percent" ? " %" : " ₹"}
                    </td>
                    <td>₹ {val?.minimum_fare || "-"}</td>
                    <td>{val?.use_per_coupon || "-"}</td>
                    <td>{val?.use_per_customer || "-"}</td>
                    <td>
                      {val?.start_date
                        ? new Date(val.start_date).toISOString().split("T")[0]
                        : "-"}
                    </td>
                    <td>
                      {" "}
                      {val?.end_date
                        ? new Date(val.end_date).toISOString().split("T")[0]
                        : "-"}
                    </td>
                    <td>
                      {val?.image && (
                        <img
                          src={`${IDS.IMG_URL}${val?.image}`}
                          alt="Image"
                          className="tableimg"
                        />
                      )}
                    </td>
                    <td>
                      <ul>
                        {val?.Coupon_Categories?.map((category) => (
                          <li key={category.id}>
                            {category?.Vehicle_Category?.name}
                          </li>
                        ))}
                      </ul>
                    </td>
                    <td>
                      <Form.Check
                        type="switch"
                        id={`custom-switch-${val?.id}`}
                        checked={val?.status}
                        onClick={() => handleStatusModal(val?.id)}
                        label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                      />
                    </td>

                    <td>
                      <div className="action_btns">
                        <button
                          type="button"
                          className="editbtn"
                          onClick={() => {
                            setId(val?.id);

                            setTimeout(() => {
                              const element = document.querySelector(
                                ".content_body",
                              );

                              if (element) {
                                element.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });
                              } else {
                                window.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });
                              }
                            }, 100);
                          }}
                        >
                          <Link>
                            <img
                              className="icon"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icons/edit.png"
                              }
                            />
                          </Link>
                        </button>
                        <button
                          type="button"
                          className="editbtn"
                          onClick={() => handleDeleteModal(val?.id)}
                        >
                          <Link>
                            <img
                              className="icon"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/icons/delete.png"
                              }
                            />
                          </Link>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Delete_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Delete_Confirm_Modal
        handleDelete={handleDelete}
        show={deleteConfirmModal}
        onHide={() => setDeleteConfirmModal(false)}
      />

      <Confirm_Status_Change
        handleStatusChange={handleStatusChange}
        show={statusConfirmModal}
        onHide={() => setStatusConfirmModal(false)}
      />
      <Pagination_Holder
        onPageChange={coupon?.data?.current_page}
        totalPages={coupon?.data?.total_pages}
        handlePageChange={handlePageChange}
      />
    </section>
  );
};

export default Table;
